import { EventTypesEnum } from 'types/generated/client';
import ActivityBadge from 'components/ActivityBadge';
import { DetailSection } from 'components/Find/detail';
import type { FindPlayer } from 'components/Find/types';
import classNames from 'styles/utils/classNames';

interface Props {
  player: FindPlayer;
  /** `lg`: the heading and summary step up from lg, for Figma's wider "Modal M". */
  sizeDesktop?: 'lg';
}

export default function PlayerLookingFor({ player, sizeDesktop }: Props) {
  return (
    <DetailSection title="Looking for" sizeDesktop={sizeDesktop}>
      <div className="flex flex-col gap-ds-sm">
        {/* Players are badged by competitiveness ("Pickleball Casual"), like games. */}
        <ActivityBadge
          type={EventTypesEnum.OpenPlay}
          sport={player.sport}
          competitiveness={player.competitiveness}
          size="xs"
          sizeDesktop={sizeDesktop === 'lg' ? 'sm' : undefined}
        />

        <h4
          className={classNames(
            'typography-product-heading-mobile text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
            sizeDesktop === 'lg' && 'lg:typography-product-heading-desktop',
          )}
        >
          {player.lookingForSummary}
        </h4>

        {player.description && (
          <p
            className={classNames(
              'typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary',
              sizeDesktop === 'lg' && 'lg:typography-product-body',
            )}
          >
            {player.description}
          </p>
        )}
      </div>
    </DetailSection>
  );
}
